import React from 'react';

export const RidersIcon = ({ fill }) => {
  /* Previous SVG:
  return (
    <svg
      viewBox='64 64 896 896'
      focusable='false'
      data-icon='user-add'
      width='20px'
      height='20px'
      fill={fill}
      aria-hidden='true'>
      <path d='M678.3 642.4c24.2-13 51.9-20.4 81.4-20.4h.1c3 0 4.4-3.6 2.2-5.6a371.67 371.67 0 00-103.7-65.8c-.4-.2-.8-.3-1.2-.5C719.2 505 759.6 431.7 759.6 349c0-137-110.8-248-247.5-248S264.7 212 264.7 349c0 82.7 40.4 156 102.6 201.1-.4.2-.8.3-1.2.5-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 00-80.4 119.5A373.6 373.6 0 00137 888.8a8 8 0 008 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C357 628.2 432.2 597 512.2 597c56.7 0 111.1 15.7 158 45.1a8.1 8.1 0 008.1.3zM512.2 521c-45.8 0-88.9-17.9-121.4-50.4A171.2 171.2 0 01340.5 349c0-45.9 17.9-89.1 50.3-121.6S466.3 177 512.2 177s88.9 17.9 121.4 50.4A171.2 171.2 0 01683.9 349c0 45.9-17.9 89.1-50.3 121.6C601.1 503.1 558 521 512.2 521zM880 759h-84v-84c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v84h-84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h84v84c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-84h84c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'></path>
    </svg>
  );
  */
  return (
    <svg width="22" height="26" viewBox="0 0 46 48" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_346_28)">
        <path
          d="M22.5464 27.262C28.0396 27.262 33.29 29.3084 37.147 32.9241C39.8221 35.432 41.6738 38.5507 42.5562 41.9143C42.7653 42.7121 42.5414 43.4341 42.02 43.9993C41.4793 44.5853 40.6158 44.9915 39.6362 44.9915H5.45654C4.47699 44.9915 3.61345 44.5853 3.07275 43.9993C2.55146 43.4341 2.32753 42.712 2.53662 41.9143C3.41901 38.5507 5.27068 35.432 7.9458 32.9241C11.8027 29.3083 17.0532 27.262 22.5464 27.262Z"
          fill="none"
          stroke="white"
          strokeWidth="2.98"
        />
      </g>
      <path
        d="M22.5459 1.49023C25.2021 1.49023 27.7497 2.54561 29.6279 4.42383C31.506 6.30195 32.5614 8.84888 32.5615 11.5049C32.5615 14.1611 31.5061 16.7087 29.6279 18.5869C27.7497 20.4651 25.2021 21.5205 22.5459 21.5205C19.8899 21.5204 17.343 20.4649 15.4648 18.5869C13.5866 16.7087 12.5313 14.1611 12.5312 11.5049C12.5313 8.8488 13.5867 6.30197 15.4648 4.42383C17.343 2.54569 19.8898 1.49032 22.5459 1.49023Z"
        fill={fill}
        fillOpacity="0.22"
        stroke="white"
        strokeWidth="2.98"
      />
      <defs>
        <clipPath id="clip0_346_28">
          <rect width="46" height="22" fill="white" transform="translate(0 25.861)" />
        </clipPath>
      </defs>
    </svg>

  );
};
